/**
 * This file includes code from [ngx-duration-picker]
 * (https://github.com/FrancescoBorzi/ngx-duration-picker) licensed under the MIT License.
 * 
 * Copyright (c) 2018 Francesco Borzì
 * See LICENSE file for details.
 */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-duration-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './duration-picker.component.html',
  styleUrl: './duration-picker.component.scss'
})
export class DurationPickerComponent implements OnInit {
  @Input()
  set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  @Input() 
  set totalSeconds(totalSeconds: number) {
    this._hours = Math.floor(totalSeconds / 3600);
    this._minutes = Math.floor((totalSeconds % 3600) / 60);
    this._seconds = totalSeconds % 60;
  }

  @Output() valueChange = new EventEmitter<number>();

  private _disabled = false;

  get disabled(): boolean {
    return this._disabled;
  }

  private _hours = 0;
  private _minutes = 0;
  private _seconds = 0;

  config: any = {
    showHours: true,
    showMinutes: true,
    showSeconds: true,
    unitSteps: {
      years: 1,
      months: 1,
      weeks: 1,
      days: 1,
      hours: 1,
      minutes: 1,
      seconds: 1,
    },
  };

  ngOnInit() {
  }

  get hours() { return this._hours; }
  set hours(value) {
    value = this.parseNumber(value) > 0 ? value : 0;
    this._hours = value;
    this.emitNewValue();
  }

  get minutes() { return this._minutes; }
  set minutes(value) {
    value = this.parseNumber(value) > 0 ? value : 0;
    this._minutes = value;
    this.emitNewValue();
  }

  get seconds() { return this._seconds; }
  set seconds(value) {
    value = this.parseNumber(value) > 0 ? value : 0;
    this._seconds = value;
    this.emitNewValue();
  }

  get valueInSeconds() {
    return this.seconds +
      this.minutes * 60 +
      this.hours * 3600
  }

  get valueInMilliseconds() {
    return this.valueInSeconds * 1000;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  emitNewValue() {
    this.valueChange.emit(this.valueInSeconds);
  }

  parseNumber(value: any): number {
    return value ? parseInt(value, 10) : 0;
  }

  // Attach all the changes received in the options object
  attachChanges(options: any): void {
    Object.keys(options).forEach((param: string) => {
      if (this.config.hasOwnProperty(param)) {
        if (typeof (this.config)[param] === 'object') {
          (this.config)[param] = {
            ...(this.config)[param],
            ...options[param]
          };
        } else {
          (this.config)[param] = options[param];
        }
      }
    });
  }

  validateOptions(options: any): any {
    const validatedOptions: any = { ...options };

    if (typeof options.unitSteps === 'object' && Object.values(options.unitSteps).some((unitStep: any) => unitStep <= 0)) {
      console.warn('Use positive values for unit steps');
      validatedOptions.unitSteps = Object.keys(options.unitSteps).reduce((steps: any, unit) => {
        steps[unit] = options.unitSteps[unit] > 0 ? options.unitSteps[unit] : 1;
        return steps;
      }, {});
    }

    return validatedOptions;
  }
}
